import styled from "styled-components"
import Breakpoints from "../../components/shared/breakpoints"
import { Block } from "../atoms/layout-primitives"

export const PostContainer = styled(Block)`
  display: flex;
  flex-direction: column;

  & > * {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
  }

  & > *:not(:last-child) {
    margin-bottom: 24px;
  }

  .slick-dots {
    bottom: -40px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: nowrap;

    & > * {
      flex: 1 1 33%;
      &,
      &:not(:last-child) {
        margin: 16px;
      }
    }
  }
`

export const DividingLine = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  margin-top: 64px;
`

export const TitleContainer = styled.div`
  justify-self: center;
  margin-bottom: 48px;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2/-2;
    margin-bottom: 50px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-bottom: 64px;
    & h3 {
      font-size: 36px;
    }
    grid-column: 3 / 11;
  }
`
